<template>
  <div>
    <!--    头部开始-->
    <div class="header">
      <div class="wrap header-wrap">
        <div class="header-left">
          <img class="logo" src="@/assets/images/logo.png">
          <div class="verticalBar"></div>
          <span class="header-title">电子采购平台</span>
        </div>
        <div class="header-right">
          <img class="icon-phone" src="@/assets/images/icon-phone.png">
          <div class="header-phone-box">
            <div>平台联系方式</div>
            <div class="phone-number">0797-8682232</div>
          </div>


          <div class="user">
            <div class="login" v-if="!state.isLogin">
              <router-link :to="{ path: '/login', query: { type: true } }">
                <span class="login__text">登录</span>
              </router-link>
            </div>
            <div class="dropdown-menu" v-else>
        <span class="dropdown-menu__fullName">
          {{ state.userInfo.fullName }}
          <i class="arrow"></i>
        </span>
              <ul class="dropdown-menu__wrapper">
                <li class="dropdown-menu__item">
                  <router-link to="/userInfo">个人中心</router-link>
                </li>
<!--                <li class="dropdown-menu__item">-->
<!--                  <router-link to="/materialType">供应商入库类型</router-link>-->
<!--                </li>-->
                <li class="dropdown-menu__item">
                  <router-link to="/company">我的公司</router-link>
                </li>
<!--                <li class="dropdown-menu__item">-->
<!--                  <router-link to="/delivery">我的报价</router-link>-->
<!--                </li>-->
<!--                <li class="dropdown-menu__item">-->
<!--                  <router-link to="/bidDelivery">我的投标</router-link>-->
<!--                </li>-->
                <li class="dropdown-menu__item" @click="handleLogout">退出</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    头部结束-->
    <!--   菜单开始     -->
    <div class="menu">
      <div class="wrap menu-wrap">
        <router-link to="/" exact v-slot="{ href, navigate, isActive }">
          <a :class="['menu-item', isActive?'selected':'' ]" :href="href" @click="navigate">首页</a>
        </router-link>
        <router-link to="/EnquiryNotices" exact v-slot="{ href, navigate, isActive }">
          <a :href="href" @click="navigate" :class="['menu-item', isActive?'selected':'' ]">询价报价</a>
        </router-link>
        <router-link to="/inviteBid" exact v-slot="{ href, navigate, isActive }">
          <a :href="href" @click="navigate" :class="['menu-item', isActive?'selected':'' ]">平台招投标</a>
        </router-link>
        <router-link to="/publicBid" exact v-slot="{ href, navigate, isActive }">
          <a :href="href" @click="navigate" :class="['menu-item', isActive?'selected':'' ]">公开招标公告</a>
        </router-link>
        <router-link to="/postscript" exact v-slot="{ href, navigate, isActive }">
          <a :href="href" @click="navigate" :class="['menu-item', isActive?'selected':'' ]">澄清补遗</a>
        </router-link>
        <router-link to="/bidAnnounce" exact v-slot="{ href, navigate, isActive }">
          <a :href="href" @click="navigate" :class="['menu-item', isActive?'selected':'' ]">中标公示</a>
        </router-link>
        <router-link to="/misconduct" exact v-slot="{ href, navigate, isActive }">
          <a :href="href" @click="navigate" :class="['menu-item', isActive?'selected':'' ]">不良行为处理</a>
        </router-link>
        <router-link to="/inviteSuppliers" exact v-slot="{ href, navigate, isActive }">
          <a :href="href" @click="navigate" :class="['menu-item', isActive?'selected':'' ]">招募供应商</a>
        </router-link>
        <router-link to="/complain" exact v-slot="{ href, navigate, isActive }">
          <a :href="href" @click="navigate" :class="['menu-item', isActive?'selected':'' ]">投诉意见箱</a>
        </router-link>
      </div>
    </div>
    <!--   菜单结束     -->
  </div>
</template>
<script>
import store from "@/store";
export default {
  name: "Header",
  data: () => ({
    state: store.state,
  }),
  created() {
    //store.requestUserInfo();
  },
  props: {
    fixedToTop: {
      type: Boolean,
      default: false,
    },
    themeColor: {
      type: String,
      default: "main-color",
    },
  },
  methods: {
    handleLogout() {
      store
        .requestLogout()
        .then((res) => {
          this.$router.push("/");
        })
        .catch((err) => {
          throw err;
        });
    },
  },
};
</script>
<style lang="less" scoped>
  .wrap{
    width: 1200px;
    margin: 0 auto;
  }
  .header{
    background-color: #fff;
    height: 100px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .header-wrap{
      display: flex;
      justify-content: space-between;
    }
    .header-left{
      display: flex;
      align-items: center;
    }
    .header-right{
      display: flex;
      align-items: center;
      .icon-phone{
        width: 45px;
        height: 45px;
        margin-right: 10px;
      }
      .header-phone-box{
        font-size: 16px;
        color: #333;
        .phone-number{
          color: #c6000b;
          font-weight: bold;
          line-height: 20px;
          letter-spacing: 1px;
          font-family: MicrosoftYaHei;
        }
      }
      @media(max-width:960px){
        .header-phone-box{
          display: none;
        }
        .icon-phone{
          display: none;
        }
      }
    }
    .logo{
      width: 270px;
      height: 60px;
    }
    @media(max-width:960px){
      .logo{
        width: 148px;
        height: 33px;
      }
    }
    // 竖线
    .verticalBar{
      width: 1px;
      border: 1px solid #ccc;
      height: 40px;
      margin-left: 14px;
      margin-right: 20px;
    }
    .header-title{
      font-size: 16px;
      color: #333;
    }
  }

  /*菜单栏*/
  .menu{
    width: 100%;
    height: 60px;
    background-color: #2b579e;
    line-height: 60px;
    .menu-wrap{
      display: flex;
      align-items: center;
      .menu-item{
        width: 133px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 18px;
        cursor: pointer;
        position: relative;
      }
      .menu-item.selected{
        background-color: #22467f;
      }
      .menu-item:hover{
        background-color: #22467f;
      }
      .menu-item::after{
        content:"";
        width:1px;
        height:20px;
        position:absolute;
        top:20px;
        right:0;
        background:#95abcf;
      }
      .menu-item:last-child::after{
        display: block;
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        right: 0;
        top: 0px;
      }
    }
  }
  @media(max-width:960px){
    .menu{
      overflow-x: auto;
      display: -webkit-box;
      -webkit-overflow-scrolling: touch;
      height: 45px;
    }
    .menu-wrap{
      width: 900px;
      overflow-y: hidden;
      .menu-item{
        font-size: 14px !important;
        width: 100px !important;
        height: 40px !important;
      }
    }
    .menu-item::after{
      top:15px !important;
    }
  }



  .user {
    margin-left: 40px;
    position: relative;

    .arrow {
      display: inline-block;
      border: 1px solid;
      border-width: 1px 1px 0 0;
      transform: rotate(135deg);
      transform-origin: center;
      vertical-align: 5px;
      margin-left: 5px;
      transition: all 0.3s;
      width: 10px;
      height: 10px;
    }

    &:hover {
      .arrow {
        transform: rotate(-45deg);
        vertical-align: -3px;
      }

      .dropdown-menu__wrapper {
        display: block;
      }
    }

    .dropdown-menu {
      position: relative;
      z-index: 1000;
      min-width: 70px;
      &__fullName {
        line-height: 2;
        cursor: pointer;
      }

      &__wrapper {
        position: absolute;
        display: none;
        right: 0;
        color: @regular-text-color;
        padding: 9px 0;
        width: 100px;
        border-radius: 5px;
        box-shadow: 0 0px 2px 1px #eee;
        background: #fff;
      }

      &__item {
        padding: 8px 12px;
        cursor: pointer;

        &:hover {
          background: #efefef58;
        }
      }
    }
  }
  .login{
    min-width: 50px;
  }
  @media(max-width:960px){
    .header{
      height: 65px;
    }
  }

</style>
